export async function getSha256(str: string): Promise<string> {
  const buf = new TextEncoder().encode(str);
  const hashBuf = await crypto.subtle.digest('SHA-256', buf);
  return Array.from(new Uint8Array(hashBuf))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

/**
 * Deterministic JSON stringifier that sorts object keys recursively.
 * Ensures the exact same SHA-256 hash is computed across different browsers/devices,
 * preventing false conflict detection caused by JS engine key-iteration differences.
 */
export function stringifyCanonicalJson(obj: unknown): string {
  if (obj === null || typeof obj !== 'object') {
    return JSON.stringify(obj);
  }
  if (Array.isArray(obj)) {
    return '[' + obj.map(item => stringifyCanonicalJson(item)).join(',') + ']';
  }
  const rec = obj as Record<string, unknown>;
  const keys = Object.keys(rec).sort();
  const entries = keys.map(key => JSON.stringify(key) + ':' + stringifyCanonicalJson(rec[key]));
  return '{' + entries.join(',') + '}';
}
